import { PaymentMethod } from '@/types/models';

/**
 * Display labels for `PaymentMethod`. Naive capitalisation renders the acronym
 * methods wrong ("Ach", "ACH" → "Ach"), so the mapping is explicit.
 */
const PAYMENT_METHOD_LABELS: Record<string, string> = {
	[PaymentMethod.Cash]: 'Cash',
	[PaymentMethod.Check]: 'Check',
	[PaymentMethod.ACH]: 'ACH',
	[PaymentMethod.Card]: 'Card',
	[PaymentMethod.Other]: 'Other',
};

/** Human label for a payment method, falling back to the raw value. */
export function paymentMethodLabel(method?: string | null): string {
	const key = String(method ?? '').toLowerCase();
	return PAYMENT_METHOD_LABELS[key] ?? String(method ?? '');
}

/**
 * Method label with its reference appended — but only when the reference adds
 * information. Owner ACH payments are routinely entered with the reference
 * "ACH", which would otherwise read "ACH #ACH" on the deposit slip and picker.
 *
 * @param refPrefix Rendered before the reference (e.g. '#' for check numbers).
 */
export function paymentMethodWithReference(
	method?: string | null,
	reference?: string | null,
	refPrefix = '',
): string {
	const label = paymentMethodLabel(method);
	const ref = (reference ?? '').trim();
	if (!ref) return label;
	// Compare against BOTH the raw method and its label so 'ach'/'ACH' both match.
	const key = String(method ?? '').toLowerCase();
	if (ref.toLowerCase() === key || ref.toLowerCase() === label.toLowerCase()) return label;
	return `${label} ${refPrefix}${ref}`;
}
